import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more-dots",
  "use": "icon-more-dots-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-more-dots\"><circle cx=\"6\" cy=\"12\" r=\"2\" transform=\"rotate(-90 6 12)\" /><circle cx=\"18\" cy=\"12\" r=\"2\" transform=\"rotate(-90 18 12)\" /><circle cx=\"12\" cy=\"12\" r=\"2\" transform=\"rotate(-90 12 12)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol